var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45V30H0V0Z",
    fill: "#E2E4E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4949 16.0133C34.5362 16.0133 35.1962 15.2506 35.1962 14.0333C35.1962 12.8159 34.5362 12.0533 33.4949 12.0533H30.7962V16.0133H33.4949ZM28.5669 21.2639V10.1466H33.9789C36.0029 10.1466 37.4256 11.7159 37.4256 13.9453C37.4256 15.2653 36.9856 16.5266 35.2109 17.5239L37.9536 21.2639H35.1962L32.7322 17.9199H30.7962V21.2639H28.5669Z",
    fill: "#3C3C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8566 19.4453C23.9539 19.4453 25.2593 18.008 25.2593 15.7053C25.2593 13.4026 23.9539 11.9653 21.8566 11.9653C19.7593 11.9653 18.4539 13.4026 18.4539 15.7053C18.4539 18.008 19.7593 19.4453 21.8566 19.4453ZM16.2246 15.7053C16.2246 12.376 18.5566 10.0293 21.8566 10.0293C25.1566 10.0293 27.4886 12.376 27.4886 15.7053C27.4886 19.0346 25.1566 21.3813 21.8566 21.3813C18.5566 21.3813 16.2246 19.0346 16.2246 15.7053Z",
    fill: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4129 10.132L12.0423 14.9573L16.4716 21.264H13.7436L10.5169 16.6586L8.5516 18.888V21.264H6.32227V10.1613H8.5516V15.5L13.4063 10.132H16.4129Z",
    fill: "#3C3C3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKor);
export default __webpack_public_path__ + "static/media/icon_kor.9e2f794e9f710892e819719fe7cc58bf.svg";
export { ForwardRef as ReactComponent };